import {addDocByName, getHttpsCallable, updateDocByName} from "@/shared/firebase_utils";
import {doc} from "firebase/firestore";

class Sponsor {
	constructor({ uid = "", evokeAGId = "", name = "", website = "", logoURL = "", firstName = "", lastName = "", email = "" , isReviewed = false, promoterType = "", bio = "",  generalPhone = "", generalEmail = "", facebook = "", instagram = "", linkedin = "", twitter = "", youtube = "", podcast = "", eventId = "", sponsorDocRef = "", sponsorType = "", promoCode = "", status = "Draft"}) {
		(this.uid = uid || ""),
		(this.evokeAGId = evokeAGId || ""),
		(this.name = name || ""),
		(this.website = website || ""),
		(this.logoURL = logoURL || ""),
		(this.firstName = firstName || ""),
		(this.lastName = lastName || ""),
		(this.email = email || ""),
		(this.isReviewed = isReviewed || false),
		(this.promoterType = promoterType || "Sponsor"),
		(this.bio = bio || ""),
		(this.generalPhone = generalPhone || ""),
		(this.generalEmail = generalEmail || ""),
		(this.facebook = facebook || ""),
		(this.instagram = instagram || ""),
		(this.linkedin = linkedin || ""),
		(this.twitter = twitter || ""),
		(this.youtube = youtube || ""),
		(this.podcast = podcast || ""),
		(this.eventId = eventId || ""),
		(this.sponsorDocRef = sponsorDocRef || ""),
		(this.sponsorType = sponsorType || ""),
		(this.promoCode = promoCode || ""),
		(this.status = status || "Draft");
	}

	static fromObject(sponsor){
		return new Sponsor({
			uid:sponsor.uid || "",
			evokeAGId:sponsor.evokeAGId || "",
			name:sponsor.name || "",
			website: sponsor.website || "",
			logoURL: sponsor.logoURL || "",
			firstName: sponsor.firstName || "",
			lastName: sponsor.lastName || "",
			email: sponsor.email || "",
			isReviewed: sponsor.isReviewed || false,
			promoterType: sponsor.promoterType || "Sponsor",
			bio: sponsor.bio || "",
			generalPhone: sponsor.generalPhone || "",
			generalEmail: sponsor.generalEmail || "",
			facebook: sponsor.facebook || "",
			instagram: sponsor.instagram || "",
			linkedin: sponsor.linkedin || "",
			twitter: sponsor.twitter || "",
			youtube: sponsor.youtube || "",
			podcast: sponsor.podcast || "",
			eventId: sponsor.eventId || "",
			sponsorDocRef: sponsor.sponsorDocRef || "",
			sponsorType: sponsor.sponsorType || "",
			promoCode: sponsor.promoCode || "",
			status: sponsor.status || "Draft"
		});
	}

	toObject(){
		return {
			uid:this.uid || "",
			evokeAGId:this.evokeAGId || "",
			name:this.name || "",
			website: this.website || "",
			logoURL: this.logoURL || "",
			firstName: this.firstName || "",
			lastName: this.lastName || "",
			email: this.email || "",
			isReviewed: this.isReviewed || false,
			promoterType: this.promoterType || "Sponsor",
			bio: this.bio || "",
			generalPhone: this.generalPhone || "",
			generalEmail: this.generalEmail || "",
			facebook: this.facebook || "",
			instagram: this.instagram || "",
			linkedin: this.linkedin || "",
			twitter: this.twitter || "",
			youtube: this.youtube || "",
			podcast: this.podcast || "",
			eventId: this.eventId || "",
			sponsorDocRef: this.sponsorDocRef || "",
			sponsorType: this.sponsorType || "",
			promoCode: this.promoCode || "",
			status: this.status || "Draft"
		}
	}

	toEventObject() {
		return {
			uid: this.uid || "",
			evokeAGId: this.evokeAGId || "",
			name: this.name || "",
			logoURL: this.logoURL || "",
			sponsorDocRef: this.sponsorDocRef,
			website: this.website || "",
			isReviewed: this.isReviewed || false,
			sponsorType: this.sponsorType || ""
		}
	}

	async save() {
		console.log(this.toObject());
		let collectionName = this.promoterType == "startup" || this.promoterType == "scaleup" ? "featuredCompanies" : "sponsors";
		try {
			if (this.sponsorDocRef != null && this.sponsorDocRef != undefined && this.sponsorDocRef != "") {
				await updateDocByName(collectionName, this.sponsorDocRef, this.toObject());
				return this.sponsorDocRef;
			}
			else {
				const ref = await addDocByName(collectionName, this.toObject());
				await updateDocByName(collectionName, ref.id, {sponsorDocRef: ref.id});
				return ref.id;
			}
		} catch (error) {
			console.log("Error occurred while adding event to firestore - ", error.message);
		}
	}

	async sendInvitationEmail(eventId, eventName, hostName, sponsorsAccessCategory){
		let link="";
		if(sponsorsAccessCategory == "subEvent") link = "https://business.pappyon.com/subEvent/"+eventId+"/sponsor/" + this.uid;
		else link="https://business.pappyon.com/event/"+eventId+"/sponsor/" + this.uid;
		 
		const sendInvitation = getHttpsCallable("sendInvitationToSponsor");
		let result = await sendInvitation({
		email: this.email,
		eventName: eventName,
		firstName: this.firstName,
		lastName: this.lastName,
		addEditSponsorDetailsLink: link,
		hostName: hostName,
		businessName: this.name
		});
		return result;
	}

	async sendReviewCompletedEmail(eventId, eventName, hostName, sponsorsAccessCategory){
		let link="";
		if(sponsorsAccessCategory == "subEvent") link = "https://business.pappyon.com/subEvent/"+eventId+"/sponsor/" + this.uid;
		else link="https://business.pappyon.com/event/"+eventId+"/sponsor/" + this.uid;

		const sendReviewCompletedEmail = getHttpsCallable("sendReviewCompletedEmailToSponsor");
		let result = await sendReviewCompletedEmail({
		email: this.email,
		eventName: eventName,
		firstName: this.firstName,
		lastName: this.lastName,
		addEditSponsorDetailsLink: link,
		hostName: hostName,
		businessName: this.name
		});
		return result;
	}
}

export default Sponsor;